import { render, staticRenderFns } from "./QuoteItem.vue?vue&type=template&id=e2184a16&"
import script from "./QuoteItem.vue?vue&type=script&lang=js&"
export * from "./QuoteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports